'use client';

import { PageDetailHeader } from '../atomic-organisms';

type DetailPageShellProps = {
  title: string;
  editHref: string;
  editText?: string;
  editAriaLabel?: string;
  onBack?: () => void;
  children: React.ReactNode;
};

export function DetailPageShell({
  title,
  editHref,
  editText = 'Edit',
  editAriaLabel = 'Edit',
  onBack,
  children,
}: DetailPageShellProps) {
  return (
    <section
      style={{
        display: 'grid',
        gap: '1rem',
        maxWidth: 'var(--nn-global-max-width)',
        padding: '0.3rem',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
      }}
    >
      <PageDetailHeader
        title={title}
        editHref={editHref}
        editText={editText}
        editAriaLabel={editAriaLabel}
        onBack={onBack}
      />

      {children}
    </section>
  );
}
